<h1 class="settlements-main-page-title" data-cy="settlements-main-page-title">{{tableTitle}}</h1>

<app-segmented-button (selectedOption)="changeListTab($event)"
  [options]="$safeNavigationMigration(state?.listTypeOptions)">
</app-segmented-button>

<app-table (clearAllFiltersClick)="clearAllFilters()"
  (selectedLine)="loadDetailData($event)"
  (sortedBy)="sortedByChange($event)"
  [accordionLineTemplate]="accordionLineTemplate"
  [hasClearAllButton]="hasClearAllButton"
  [initiallySortedBy]="initiallySortedBy"
  [scrollEvent]="scrollEvent"
  [tableData]="tableData"
  tableName="table">
</app-table>

@if (hasPagination()) {
  <app-pagination (pageNumber)="changePage($event)"
    [collectionSize]="search.totalResults"
    [pageSize]="search.pageSize"
    [page]="search.pageNumber"
    data-cy="settlements-list-pagination">
  </app-pagination>
}

<!-- FIXME: this should belong to the new table component, to keep consistent behavior between the old table and the new one. -->
@if (spinnerObservable | async) {
  <div class="spinner-container">
    <app-loading-spinner class="center-spinner"></app-loading-spinner>
  </div>
}

<ng-template #customerFilterTemplate>
  <app-code-filter #customerFilter
    (filterEvent)="filterChange($event)"
    (onOpen)="getCustomerFilterCodes()"
    [dataSubject]="customerFilterCodes"
    [filterName]="SettlementColumnEnum.CUSTOMER"
  placeHolder="Search by Supplier"></app-code-filter>
</ng-template>

<ng-template #supplierFilterTemplate>
  <app-code-filter #supplierFilter
    (filterEvent)="filterChange($event)"
    (onOpen)="getSupplierFilterCodes()"
    [dataSubject]="supplierFilterCodes"
    [filterName]="SettlementColumnEnum.SUPPLIER"
  placeHolder="Search by Supplier"></app-code-filter>
</ng-template>

<ng-template #complaintCodeFilterTemplate>
  <app-input-and-code-filter #complaintCodeFilter
    (filterEvent)="filterChange($event)"
    [filterName]="SettlementColumnEnum.COMPLAINT_CODE"
  placeHolder="Search by Complaint No."></app-input-and-code-filter>
</ng-template>

<ng-template #settlementCodeFilterTemplate>
  <app-input-and-code-filter #settlementCodeFilter
    (filterEvent)="filterChange($event)"
    [filterName]="SettlementColumnEnum.SETTLEMENT_CODE"
  placeHolder="Search by Settlement No."></app-input-and-code-filter>
</ng-template>

<ng-template #statusFilterTemplate>
  <app-code-filter #statusFilter
    (filterEvent)="filterChange($event)"
    (onOpen)="getStatusFilterCodes()"
    [dataSubject]="statusFilterCodes"
    [filterName]="SettlementColumnEnum.STATUS"
    [formatWithoutCode]="true"
  placeHolder="Search by status"></app-code-filter>
</ng-template>

<ng-template #lastPendingDateFilterTemplate>
  <app-date-filter #lastPendingDateFilter
    (filterEvent)="filterChange($event)"
    [dateDisplayedInUtc]="false"
    [filterName]="SettlementColumnEnum.LAST_PENDING_DATE"
  placeHolder="Search by status"></app-date-filter>
</ng-template>

<ng-template #lastChangeDatetimeFilterTemplate>
  <app-date-filter #lastChangeDatetimeFilter
    (filterEvent)="filterChange($event)"
    [dateDisplayedInUtc]="false"
    [filterName]="SettlementColumnEnum.LAST_CHANGE_DATETIME"
  placeHolder="Search by status"></app-date-filter>
</ng-template>

<ng-template #partTotalFilterTemplate>
  <app-number-filter #partTotalFilterFilter
    (filterEvent)="filterChange($event)"
    [filterName]="SettlementColumnEnum.MATERIALS_TOTAL_GROSS_COST"
  operatorPlaceholder="Gross amount"></app-number-filter>
</ng-template>

<ng-template #teMinutesFilterTemplate>
  <app-number-filter #teMinutesFilter
    (filterEvent)="filterChange($event)"
    [filterName]="SettlementColumnEnum.TE_MINUTES_TOTAL_COST"
  operatorPlaceholder="Gross amount"></app-number-filter>
</ng-template>

<ng-template #settlementGrossAmountFilterTemplate>
  <app-number-filter #settlementGrossAmountFilter
    (filterEvent)="filterChange($event)"
    [filterName]="SettlementColumnEnum.SETTLEMENT_TOTAL_COST"
  operatorPlaceholder="Gross amount"></app-number-filter>
</ng-template>

<ng-template #accordionLineTemplate>
  <app-settlement-detail (footerAction)="triggerFooterAction($event)"
  [detailData]="accordionContext"></app-settlement-detail>
</ng-template>
